__turbopack_context__.v({
  "animate-popover-in": "aq1Svq_animate-popover-in",
  "animate-popover-out": "aq1Svq_animate-popover-out",
  "popover-in": "aq1Svq_popover-in",
  "popover-out": "aq1Svq_popover-out",
});
